import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { SelectOption } from "shared/types/Select"
import { SortOrder } from "shared/types/SortOrder"

import { ProjectSortKey } from "entities/projects/model/useProjectSorting"

export function useProjectSortOptions(): SelectOption<string>[] {
  const { t } = useTranslation()

  return useMemo(
    () =>
      [
        {
          label: t("ProjectSort.CreatedAtAsc"),
          value: `${ProjectSortKey.CREATED_AT}:${SortOrder.ASC}`
        },
        {
          label: t("ProjectSort.CreatedAtDesc"),
          value: `${ProjectSortKey.CREATED_AT}:${SortOrder.DESC}`
        },
        {
          label: t("ProjectSort.UpdatedAtAsc"),
          value: `${ProjectSortKey.UPDATED_AT}:${SortOrder.ASC}`
        },
        {
          label: t("ProjectSort.UpdatedAtDesc"),
          value: `${ProjectSortKey.UPDATED_AT}:${SortOrder.DESC}`
        },
        {
          label: t("ProjectSort.TitleAsc"),
          value: `${ProjectSortKey.TITLE}:${SortOrder.ASC}`
        },
        {
          label: t("ProjectSort.TitleDesc"),
          value: `${ProjectSortKey.TITLE}:${SortOrder.DESC}`
        }
      ] as SelectOption<string>[],
    [t]
  )
}
